<template>
    <div>
        <!-- Modal Seleção Tempos -->
        <div class="modal fade" id="selecaoTempoCurvaModal" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="selecao">
                    <div class="modal-header">
                        <h5 class="modal-title">Seleção</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="(curva, icx) in selecao" :key="icx">
                            <div class="alert d-flex justify-content-between" :class="( curva.conf_selec || selecionados(curva) == curva.tempos ) ? 'alert-success' : 'alert-danger'">
                                <div>
                                    {{ curva.proc.search }} 
                                </div>
                                <div>
                                    <span class="badge badge-success" v-if="curva.conf_selec">
                                        {{ selecionados(curva) }}/{{ curva.items.length }}
                                    </span>

                                    <span class="badge" :class="selecionados(curva) == curva.tempos ? 'badge-success' : 'badge-danger'" v-else>
                                        {{ selecionados(curva) }}/{{ curva.tempos }}
                                    </span>
                                </div>
                            </div>

                            <az-input
                                type="number"
                                label="Tempos/Dosagens"
                                v-if="!curva.conf_selec"
                                v-model="curva.tempos" />

                            <div v-for="(item, index) in ordernar_lista(curva.items, 'id_consumo_procedimento')" :key="index">
                                <az-input
                                    v-if="item.procedimento"
                                    type="checkbox-group"
                                    :label="item.procedimento.search"
                                    :edicao="item.curv || selecionados(curva) != curva.tempos"
                                    v-model="item.curv">
                                    <template v-slot:buttonposcb>
                                        <div class="input-group-append">
                                            <button type="button" class="btn btn-outline-secondary" @click="item.nao_coletar = !item.nao_coletar" title="Coletar/Não Coletar">
                                                <i class="fa-solid fa-ban fa-fw" v-if="item.nao_coletar"></i>
                                                <i class="fa-regular fa-circle fa-fw" v-else></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>

                                <az-input
                                    v-else
                                    type="checkbox-group"
                                    :label="item.search"
                                    v-model="item.curv">
                                </az-input>
                            </div>
                        </div>

                        <pre v-if="false">{{ selecao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" :disabled="!pode_fechar" @click="concluir()">Concluir</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            selecao: null, 
            callback: null,
        };
    },

    components: { 
        AzInput,
    },

    computed: { 
        pode_fechar: function () { 
            if ( !this.selecao ) { 
                return true;
            } 

            return this.selecao.every(curva => curva.conf_selec ||  ( this.selecionados(curva) == curva.tempos ) );
        },
    },

    methods: {
        ordernar_lista (lista, campo) { 
            return _.orderBy(lista, campo);
        },
        selecionados (lista) { 
            return lista.items.filter(item => item.curv).length;
        },

        abrir(lista, callback) {
            lista.forEach(curva => { 
                curva.items.forEach(item => {
                    item.curv = false;
                    item.excluido = true;
                    item.fl_ativo = false;
                });
            });

            this.selecao = lista;
            this.callback = callback;

            $("#selecaoTempoCurvaModal").modal('show');
        },

        fechar () { 
            $("#selecaoTempoCurvaModal").modal('hide');
        },

        concluir() { 
            this.selecao.forEach(curva => curva.items.forEach(item => { 
                    item.excluido = !item.curv;
                    item.fl_ativo = item.curv;
                    //item.nao_coletar = true;

                    if ( !item.js_solics ) { 
                        item.js_solics = { 
                            curv: curva.proc ? curva.proc.id_procedimento : true 
                        };
                    } else { 
                        item.js_solics.curv = curva.proc ? curva.proc.id_procedimento : true;
                    }
                })
            );

            this.fechar();
        }
    }, 

    mounted() { 
        $("#selecaoTempoCurvaModal").on('hidden.bs.modal', () => {
            if ( this.callback ) { 
                this.callback(); 
            }
        });
    }
}
</script>
